import {Component} from 'vue-property-decorator'
import Vue from 'vue'
import {namespace} from 'vuex-class'
import {
  AM_MODULE_NAMESPACE,
  AM_SET_ATTACHMENT_TYPE_BY_FIELD,
} from '../../../../store/agency-management'
import {CrudStatus} from "../../../../common/enums";

const AMStore = namespace(AM_MODULE_NAMESPACE)

@Component
class AmAttachmentTypeModalVertical extends Vue {
  @AMStore.Mutation(AM_SET_ATTACHMENT_TYPE_BY_FIELD)
  storeSetAttachmentTypeByValue: (payload: any) => void

  @AMStore.Getter attachmentTypeToEdit: any
  @AMStore.Getter attachmentType: any
  @AMStore.Getter amCrudActionStatus: CrudStatus

  levels: any[];
  parentAttachmentTypes: any[];
  hoverPicto: boolean;
  loadUpdatePicto: boolean
  loaderValue: any;
  file: any;
  dtDocumentConfigs: { minimum: number, image: { alpha: number }, video: { alpha: number }, document: { alpha: number } }
  dtRules: {
    name?: any,
    level?: any
  }

  constructor () {
    super()
    this.dtRules = {}
    this.levels = [
      {name: 'Catégorie', value: 1},
      {name: 'Sous-catégorie', value: 2}
    ]
    this.parentAttachmentTypes = []
    this.hoverPicto = false
    this.loadUpdatePicto = false
    this.loaderValue = { percentage: 0 };
    this.file = null;
    this.dtDocumentConfigs = null;
  }

  mounted () {
    this.dtDocumentConfigs = require('../../../../configs/ticket-document-maxsize.config.json');
    this.dtRules = {
      level: [v=>!!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.amCharPbLevel)})],
      name: [v=>!!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.amCharPbName)})]
    }
    if (!this.isUpdate) {
      this.level = this.calledFromList ? 1 : 2
      if (this.level === 2) {
        this.parentAttachmentTypes = [{name: this.attachmentType.name, value: this.attachmentType.id}]
        this.parent = this.attachmentType.id
      }
    }
    if (this.level === 2 && this.isUpdate) {
      this.parentAttachmentTypes = [{
        name: this.attachmentType.parent.name,
        value: this.attachmentType.parent.id
      }]
    }
  }

  get lblSetting () {
    return {
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/agency-management').default
    }
  }

  get calledFromList (): boolean {
    return this.$route.path === '/profile/attachment-type'
  }

  get isUpdate (): boolean {
    return this.amCrudActionStatus === CrudStatus.Update
  }

  get level () {
    return this.attachmentTypeToEdit.level
  }

  set level (value: number) {
    this.storeSetAttachmentTypeByValue({level: value})
  }

  get name () {
    return this.attachmentTypeToEdit.name || ''
  }

  set name (value: number) {
    this.storeSetAttachmentTypeByValue({name: value})
  }

  get picto () {
    return this.attachmentTypeToEdit.picto || ''
  }

  set picto (value: number) {
    this.storeSetAttachmentTypeByValue({picto: value})
  }

  get parent () {
    return this.attachmentTypeToEdit.fk_doc_type_parent || ''
  }

  set parent (value: number) {
    this.storeSetAttachmentTypeByValue({fk_doc_type_parent: value})
  }

  handleEditPicto () {
    if(!this.loadUpdatePicto) (this.$refs['file'] as any).click();
  }

  handlePictoMouseOver() {
    this.hoverPicto = true
  }

  handlePictoMouseLeave() {
    this.hoverPicto = false
  }

  async handleFileUpload({ files }) {
    if (files.length === 0) return;
    const maxSize: number = this.calculateMaxSize('image');
    if (maxSize < files[0].size) {
      alert(`File too large. The size can not exceed ${maxSize / 1024 / 1024}`);
      return;
    }
    await this.getBase64URL(files[0])
      .then((fileReader: FileReader) => {
        const file = files[0];
        file.id = `${file.lastModified}`;
        fileReader.onloadend = () => {
          file.url = fileReader.result;
        }
        return Promise.resolve(file)
      })
      .then(file => {
        setTimeout(() => {
          this.file = file;
          this.loaderValue.percentage= 100
          //this.$emit('updateImage',file.url)
          this.picto = file.url
        }, 100);
      })
      .catch(error => console.log(error))
  }

  paramImage(params) {
    params.picture = this.file.url;
    params.percentage = 0;
    this.loaderValue = params;
  }

  private async getBase64URL(file): Promise<FileReader> {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    return Promise.resolve(fileReader);
  }

  private calculateMaxSize(type): number {
    return this.dtDocumentConfigs[type].alpha * this.dtDocumentConfigs.minimum
  }
}

export default AmAttachmentTypeModalVertical



// WEBPACK FOOTER //
// ./src/containers/profile/components/am-attachment-type-modal-vertical/index.ts